import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['dashboard', 'dashboard__staff', 'grid', 'grid--vertical'])
}
const _hoisted_2 = { class: "grid__cell" }
const _hoisted_3 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_chart = _resolveComponent("chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([
					'dashboard__quick-access',
					'dashboard__staff-quick-access',
					'grid',
					_ctx.mobileVersion ? 'grid--vertical' : 'grid--horizontal'
				])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (item.show)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: item.url,
                  class: "grid__cell"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass([
										'dashboard__quick-access-item',
										'dashboard__staff-quick-access-item',
										{ 'is-mobile': _ctx.mobileVersion }
									])
                        }, [
                          _createVNode(_component_Icon, {
                            icon: item.icon,
                            height: "60px",
                            style: { color: '#3db2c7' }
                          }, null, 8, ["icon"]),
                          _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1)
                        ], 2)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ], 2)
    ]),
    (!_ctx.mobileVersion)
      ? (_openBlock(), _createBlock(_component_chart, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}